// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-md) 0;
  margin-bottom: var(--spacing-lg);
  border-bottom: 1px solid var(--border-color);
}

.header-left {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.header-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.header-icon {
  font-size: 1.75rem;
}

.header-location {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.header-right {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 4px;
}

.last-updated {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 0.85rem;
}

.update-label {
  color: var(--text-muted);
}

.update-time {
  color: var(--text-secondary);
  font-family: 'Monaco', 'Consolas', monospace;
}

.refresh-btn {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  background: transparent;
  border: none;
  border-radius: var(--radius-md);
  color: var(--text-primary);
  cursor: pointer;
  transition: all var(--transition-fast);
  font-size: 0.85rem;
}

.refresh-btn:hover:not(:disabled) {
  background: var(--bg-card-hover);
}

.refresh-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.refresh-btn.loading .refresh-icon {
  animation: spin 1s linear infinite;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-md);
}

.tv-mode-link {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  background: transparent;
  border: none;
  border-left: 1px solid var(--border-color);
  border-radius: 0;
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.85rem;
  transition: all var(--transition-fast);
}

.tv-mode-link:hover {
  background: var(--bg-card-hover);
  color: var(--accent-blue);
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-dot.live {
  background: var(--accent-green);
  box-shadow: 0 0 8px var(--accent-green);
  animation: pulse 2s infinite;
}

.status-dot.updating {
  background: var(--accent-yellow);
  animation: pulse 0.5s infinite;
}

.status-text {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@media (max-width: 768px) {
  .header {
    flex-direction: column;
    gap: var(--spacing-md);
    align-items: flex-start;
  }
  
  .header-right {
    width: 100%;
    justify-content: space-between;
  }

  .tv-mode-link {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,uBAAuB;EACvB,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--spacing-md) 0;\n  margin-bottom: var(--spacing-lg);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.header-left {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xs);\n}\n\n.header-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.header-icon {\n  font-size: 1.75rem;\n}\n\n.header-location {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-lg);\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  padding: 4px;\n}\n\n.last-updated {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  font-size: 0.85rem;\n}\n\n.update-label {\n  color: var(--text-muted);\n}\n\n.update-time {\n  color: var(--text-secondary);\n  font-family: 'Monaco', 'Consolas', monospace;\n}\n\n.refresh-btn {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  font-size: 0.85rem;\n}\n\n.refresh-btn:hover:not(:disabled) {\n  background: var(--bg-card-hover);\n}\n\n.refresh-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.refresh-btn.loading .refresh-icon {\n  animation: spin 1s linear infinite;\n}\n\n.status-indicator {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm) var(--spacing-md);\n  border-radius: var(--radius-md);\n}\n\n.tv-mode-link {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: transparent;\n  border: none;\n  border-left: 1px solid var(--border-color);\n  border-radius: 0;\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-size: 0.85rem;\n  transition: all var(--transition-fast);\n}\n\n.tv-mode-link:hover {\n  background: var(--bg-card-hover);\n  color: var(--accent-blue);\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.status-dot.live {\n  background: var(--accent-green);\n  box-shadow: 0 0 8px var(--accent-green);\n  animation: pulse 2s infinite;\n}\n\n.status-dot.updating {\n  background: var(--accent-yellow);\n  animation: pulse 0.5s infinite;\n}\n\n.status-text {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    gap: var(--spacing-md);\n    align-items: flex-start;\n  }\n  \n  .header-right {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .tv-mode-link {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
